import React, { useState, useRef } from "react";
import { Text, Box, Tooltip } from "@radix-ui/themes";

export const TruncatedText = ({ children, size = "2", weight = "regular", color, style }) => {
  const text = typeof children === "string" ? children : String(children);
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  // Measure on hover so the tooltip only opens when the text is actually clipped
  const handleOpenChange = (nextOpen) => {
    const el = containerRef.current;
    setOpen(nextOpen && !!el && el.scrollWidth > el.clientWidth);
  };

  return (
    <Tooltip content={text} open={open} onOpenChange={handleOpenChange}>
      <Box as="span" ref={containerRef} style={{ display: "block", width: "100%", overflow: "hidden",
        textOverflow: "ellipsis", whiteSpace: "nowrap", ...style }}>
        <Text size={size} weight={weight} color={color}>
          {text}
        </Text>
      </Box>
    </Tooltip>
  );
};
